import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  questionLabel: {
    fontSize: '16px',
    transform: 'translate(0px, -8px)',
    transformOrigin: 'left top',
    color: 'rgb(69, 18, 149)',
    transition: 'color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms'
  },
  gpaQuestionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  gpaGradeContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  gpaValueInputContainer: {
    width: '140px'
  },
  gpaValueCheckboxContainer: {
    width: 'calc(100% - 160px)'
  },
  checkboxButtonLabelContainer: {
    color: '#451295',
    cursor: 'pointer'
  },
  checkboxButtonLabel: {
    color: '#451295',
    fontSize: '14px !important',
    userSelect: 'none',
    marginLeft: '10px'
  },
  checkboxButtonChecked: {
    color: '#3700d7 !important'
  },
  bottomBarRoot: {
    height: 80,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    background: '#fff',
    borderTop: '1px solid rgb(205, 205, 205)'
  },
  bottomBarContent: {
    width: '920px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around'
  },
  bottomBarTextContainer: {
    flex: 1,
    textAlign: 'center',
    color: 'rgb(74, 74, 74)',
    fontSize: '16px',
    lineHeight: '18px'
  },
  loading: {
    margin: 0,
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
}))
